<template>
  <div class="becomeAgency-wrapper">
    <div class="becomeAgency-innerSection" :style="{ backgroundImage: `url(${agnecyCenterBg})` }">
      <div class="position-relative items-center agencyCentre-headerBar text-white">
        <!-- <div class="angle" id="close" @click="viewClose('someStatus')"></div> -->
        <div class="text-center agencyCentre-headerHD">Apply to become an Agent</div>
      </div>

      <div class="becomeAgency-fromWrapper px-3 pb-4">
        <div class="agencyInfo-box text-center text-white pt-4">
          <h5 v-if="loadingAgency" class="mb-0">Loading...</h5>
          <h5 v-else-if="agencyData?.profile_id" class="mb-0">
            {{ agencyData.name }}[ID:{{ agencyData.profile_id }}]
          </h5>
          <h5 v-else class="mb-0 text-black">Agency profile ID not found</h5>
          <p>invite you to be agency</p>
        </div>

        <div class="agencyCentre-gapBG"></div>

        <div class="becomeAgency-fromInner applyBecomeAgent-form bg-white px-3 py-4 mt-3">
          <div class="becomeAgency-from">
            <!-- USER ID -->
            <div class="becomeAgency-fromItem mb-3">
              <label class="fw-semibold mb-1 d-flex align-items-center gap-1">
                <span class="required-color">*</span><span>Starmate ID :</span>
              </label>

              <!-- ✅ ONLY NUMERIC -->
              <input
                type="text"
                class="becomeAgency-formControl"
                placeholder="User ID"
                v-model="user_profile_id"
                inputmode="numeric"
                pattern="\d*"
                maxlength="15"
                @input="onUserIdInput"
                @keydown.enter.prevent="fetchUserDetails"
              />

              <small v-if="userLoading" class="text-muted">Checking user...</small>
              <small v-else-if="userError" class="text-danger">{{ userError }}</small>
            </div>

            <!-- USER INFO BOX -->
            <div v-if="userData" class="becomeAgency-fromItem userInformationBox mb-2">
              <div class="userInfoBox-inner d-flex align-items-center gap-2">
                <div class="becomeAgency-userImageBox">
                  <img :src="userImageToShow" @error="onUserImgError" alt="" />
                </div>
                <div class="becomeAgency-userNameBox">
                  {{ userData.name }} [ID:{{ userData.profile_id }}]
                </div>
              </div>
            </div>

            <!-- VERIFICATION -->
            <div class="becomeAgency-fromItem mb-3">
              <label class="fw-semibold mb-1 d-flex align-items-center gap-1">
                <span class="required-color">*</span>
                <span>Starmate verification code :</span>
              </label>

              <div class="position-relative verification-codeField">
                <input
                  type="text"
                  class="becomeAgency-formControl"
                  placeholder="verification code"
                  v-model.trim="verification_code"
                  inputmode="numeric"
                  autocomplete="one-time-code"
                  maxlength="6"
                  @input="onOtpInput"
                />

                <div
                  class="activeCode-btn d-flex justify-content-center align-items-center text-center text-white"
                  :class="disableOtpBtn ? 'opacity-70-- pe-none' : ''"
                  @click="getVerificationCode"
                >
                  {{ otpTimer > 0 ? formatOtpTime(otpTimer) : (otpSent ? "Resend" : "Get") }}
                </div>
              </div>
            </div>

            <div class="becomeAgency-from-bottomTitle mb-2">
              <p>Starmate offcial BD will contact your Whatsapp number for the support</p>
            </div>

            <div class="becomeAgency-fromItem">
              <button
                type="button"
                class="becomeAgency-fromSubmit-btn d-flex justify-content-center align-items-center text-center text-white"
                :disabled="submitLoading || !canSubmit"
                :class="submitLoading || !canSubmit ? 'opacity-70-- pe-none' : ''"
                @click="handleSubmit"
              >
                {{ submitLoading ? "Submitting..." : "Submit" }}
              </button>
            </div>

            <div v-if="submitError" class="text-danger text-center">{{ submitError }}</div>
            <div v-else-if="submitSuccess" class="text-success text-center">{{ submitSuccess }}</div>
          </div>
        </div>

        <div class="text-center text-white mt-3">
          <h5>How to get Starmate<br /> verification code?</h5>
        </div>

        <div class="becomeAgency-fromInner applyBecomeAgent-form bg-white px-3 py-4 mt-3">
          <div class="become_agent_processSteps">
            <img :src="become_agent_processSteps" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "./Become_agencyStyle.css";
import agnecyCenterBg from "../../assets/images/agency-centre/become_agency_BG.webp";
import defaultUserImage from "../../assets/images/default_profile.webp";
import become_agent_processSteps from "../../assets/images/agency-centre/become_agent_processSteps.png";
import { inviteAgencyApi } from "../../services/inviteAgencyApi";

export default {
  name: "Become_agency",

  data() {
    return {
      agnecyCenterBg,
      defaultUserImage,
      become_agent_processSteps,

      agency_profile_id: null,
      agencyData: null,
      loadingAgency: false,

      // user lookup
      user_profile_id: "",
      userData: null,
      userImgFailed: false,
      userLoading: false,
      userError: "",
      typingTimer: null,

      // form
      verification_code: "",

      // otp
      otpLoading: false,
      otpTimer: 0,
      otpInterval: null,
      otpSent: false,

      // submit
      submitLoading: false,
      submitError: "",
      submitSuccess: "",
      successTimer: null,

      // Invite landing base
      landingBase: "https://h5.starmate.co.in",
    };
  },

  computed: {
    userImageToShow() {
      const url = this.userData?.profile_images?.[0]?.image_name;
      return !url || this.userImgFailed ? this.defaultUserImage : url;
    },

    disableOtpBtn() {
      return !this.userData?.profile_id || this.otpLoading || this.otpTimer > 0;
    },

    canSubmit() {
      const agencyOk = !!this.agency_profile_id;
      const userOk = !!this.userData?.profile_id;
      const otpOk = /^\d{6}$/.test(String(this.verification_code || "").trim());
      return agencyOk && userOk && otpOk;
    },
  },

  mounted() {
    this.agency_profile_id = this.$route.params.profile_id || null;
    this.fetchInviteAgencyData();
  },

  beforeUnmount() {
    clearTimeout(this.typingTimer);
    clearTimeout(this.successTimer);
    this.stopOtpTimer();
  },

  methods: {
    // ✅ ONLY NUMERIC INPUT FOR USER ID (paste-safe)
    onUserIdInput(e) {
      const digits = String(e?.target?.value || "").replace(/\D/g, "");
      this.user_profile_id = digits;

      // keep your existing debounce/search behavior
      this.onUserIdKeyup();
    },

    // ---------- helpers ----------
    clearOtp() {
      this.stopOtpTimer();
      this.otpTimer = 0;
      this.otpSent = false;
      this.otpLoading = false;
      this.verification_code = "";
    },

    clearMessages() {
      this.userError = "";
      this.submitError = "";
      this.submitSuccess = "";
      clearTimeout(this.successTimer);
    },

    clearUserResult() {
      this.userData = null;
      this.userImgFailed = false;
      this.clearOtp();
    },

    // ---------- agency ----------
    async fetchInviteAgencyData() {
      if (!this.agency_profile_id) return;

      this.loadingAgency = true;
      try {
        const res = await inviteAgencyApi.getAgencyDetails(this.agency_profile_id);
        this.agencyData = res?.data?.result || null;
      } catch (error) {
        console.error("Agency API Error =>", error);
        this.agencyData = null;
      } finally {
        this.loadingAgency = false;
      }
    },

    // ---------- user search ----------
    onUserIdKeyup() {
      const id = String(this.user_profile_id || "").trim();

      this.clearMessages();
      this.clearOtp(); // user typing => otp reset

      clearTimeout(this.typingTimer);

      if (!id) {
        this.clearUserResult();
        return;
      }

      if (id.length < 8) {
        // don’t nuke input, just clear the fetched user
        this.userData = null;
        this.userError = "";
        this.userImgFailed = false;
        return;
      }

      this.typingTimer = setTimeout(this.fetchUserDetails, 500);
    },

    async fetchUserDetails() {
      const id = String(this.user_profile_id || "").trim();
      if (id.length < 8) return;

      this.userLoading = true;
      this.userError = "";

      try {
        const res = await inviteAgencyApi.getUserDetails(id);

        const success = !!res?.data?.success;
        const result = res?.data?.result || null;
        const apiErrorMsg = res?.data?.error || res?.data?.message || "User not found";

        if (!success || !result) {
          this.userData = null;
          this.userError = apiErrorMsg;
          this.userImgFailed = false;
          return;
        }

        this.userData = { ...result, profile_id: result.profile_id || id };
        this.userImgFailed = false;
      } catch (e) {
        this.userData = null;
        this.userError = "API error. Try again.";
        this.userImgFailed = false;
      } finally {
        this.userLoading = false;
      }
    },

    // ---------- image fallback ----------
    onUserImgError(e) {
      if (e?.target?.src === this.defaultUserImage) return;
      this.userImgFailed = true;
      e.target.src = this.defaultUserImage;
    },

    // ---------- otp ----------
    async getVerificationCode() {
      if (this.disableOtpBtn) return;

      this.otpLoading = true;
      this.userError = "";

      try {
        const res = await inviteAgencyApi.sendOtp(this.userData.profile_id);

        if (res?.data?.success) {
          this.otpSent = false;
          this.startOtpTimer();
        } else {
          this.userError = res?.data?.error || res?.data?.message || "Failed to send OTP";
        }
      } catch (err) {
        console.error("OTP API Error:", err);
        this.userError = "OTP API error. Try again.";
      } finally {
        this.otpLoading = false;
      }
    },

    onOtpInput(e) {
      this.verification_code = String(e.target.value || "").replace(/\D/g, "").slice(0, 6);
    },

    formatOtpTime(sec) {
      const m = Math.floor(sec / 60);
      const s = sec % 60;
      return `${m}:${String(s).padStart(2, "0")}`;
    },

    startOtpTimer() {
      this.stopOtpTimer();
      this.otpTimer = 600;

      this.otpInterval = setInterval(() => {
        this.otpTimer -= 1;
        if (this.otpTimer <= 0) {
          this.stopOtpTimer();
          this.otpSent = true;
        }
      }, 1000);
    },

    stopOtpTimer() {
      if (this.otpInterval) {
        clearInterval(this.otpInterval);
        this.otpInterval = null;
      }
    },

    // ---------- submit ----------
    async handleSubmit() {
      if (!this.canSubmit || this.submitLoading) return;

      this.submitLoading = true;
      this.submitError = "";
      this.submitSuccess = "";

      try {
        const payload = {
          agency_profile_id: this.agency_profile_id,
          user_profile_id: this.userData.profile_id,
          otp: String(this.verification_code || "").trim(),
        };

        const res = await inviteAgencyApi.updateUserFromInviteAgency(payload);

        if (!res?.data?.success) {
          this.submitError = res?.data?.error || res?.data?.message || "Invalid OTP or request failed";
          return;
        }

        // ✅ success message
        this.submitSuccess = res?.data?.message || "Successfully submitted";

        // ✅ reset form (keep success message visible)
        this.user_profile_id = "";
        this.clearUserResult();

        // ✅ redirect after few seconds
        clearTimeout(this.successTimer);
        this.successTimer = setTimeout(() => {
          window.location.href = `${this.landingBase}/become-agent-success`;
        }, 1000);
      } catch (err) {
        console.error("Submit API Error:", err);
        this.submitError = "Submit failed. Try again.";
      } finally {
        this.submitLoading = false;
      }
    },

    // ---------- close ----------
    // viewClose(status) {
    //   if (window.Android && typeof Android.viewClose === "function") {
    //     Android.viewClose(status);
    //   } else {
    //     window.parent.postMessage({ action: "closePopup", status }, "*");
    //   }
    // },
  },
};
</script>
